import { render } from "./Policys.vue?vue&type=template&id=36c8b7d0"
import script from "./Policys.vue?vue&type=script&lang=js"
export * from "./Policys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__